module.exports = __webpack_public_path__ + "static/media/unfall.3aa144e8.svg";